import React,{useState} from 'react'
import Search from '../components/Search'
import usePokemonFetch from '../hooks/usePokemonFetch'

export default function Home() {
    const [name,setName] = useState("tes")
    const {pokemons} = usePokemonFetch(`https://pokeapi.co/api/v2/pokemon/${name}`)
    ///fetch hasil search menggunakan hooks, agar hooksnya terpakai

    function onFormSubmit(data) {
        setName(data)
        console.log(data)
        console.log(name)
        console.log(pokemons)
    }

    return(
        <div style={{backgroundColor:"#F4F5F8"}}>
            <h2 data-testid="homepage-title" style={{textAlign:"center"}}>Welcome to PokeApp!</h2>
            <h4 style={{textAlign:"center"}}>Click Pokemon List to See Lists of Pokemon or Search by Name</h4>
            <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-4 form-group">
                    <Search onNameSubmit={onFormSubmit} style={styles.home}/>
                    {pokemons &&
                        <div className="card" style={{maxWidth: "20 rem"}}>
                            <img className="card-img-top" src={`https://pokeres.bastionbot.org/images/pokemon/${pokemons.id}.png`} alt="Cardimg" />
                            <div className="card-body">
                                <h5 className="card-title">{pokemons.name}</h5>
                            </div>
                        </div>    
                    }
                </div>
                <div className="col-md-4"></div>
            </div>
            {!pokemons && <img style={styles.home} src="https://thumbs.gfycat.com/FairSinfulCottontail-max-1mb.gif" alt="loading" />}
        </div>
    )
}

const styles = {
    home: {
        display: "block",
        margin: "0 auto"
    }
}